import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared.module';
import { ButtonComponent } from './ui/button/button.component';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IconComponent } from './ui/icon/icon.component';
import { ToggleComponent } from './ui/toggle/toggle.component';
import { DropdownComponent } from './ui/dropdown/dropdown.component';
import { InputComponent } from './ui/input/input.component';
import { DialogComponent } from './ui/dialog/dialog.component';
import { DialogExampleComponent } from './dialogs/dialog-example/dialog-example.component';
import { RankingUpdateDataComponent } from './dialogs/ranking-update-data/ranking-update-data.component';
import { QrRankingItemComponent } from './qr-ranking-item/qr-ranking-item.component';
import { InputAutocompleteComponent } from './ui/input-autocomplete/input-autocomplete.component';
import { DialogFullScreenComponent } from './ui/dialog-full-screen/dialog-full-screen.component';
import { AvatarComponent } from './ui/avatar/avatar.component';
import { TabsComponent } from './ui/tabs/tabs.component';
import { TopbarComponent } from './ui/topbar/topbar.component';
import { SkeletonLoaderComponent } from './ui/skeleton-loader/skeleton-loader.component';
import { FilterRankingComponent } from './filter-ranking/filter-ranking.component';
import { ChipComponent } from './ui/chip/chip.component';
import { ChipOutlineComponent } from './ui/chip-outline/chip-outline.component';
import { ButtonOrderComponent } from './ui/button-order/button-order.component';
import { RankingTableAveragesComponent } from './dialogs/ranking-table-averages/ranking-table-averages.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PanelHomeComponent } from './panel-components/home/home.component';
import { TableHeaderComponent } from './ui/table-header/table-header.component';
import { DialogLimpiarCuentaCorriente } from './dialogs/dialog-limpiar-cuenta-corriente/dialog-limpiar-cuenta-corriente.component';
import { DialogRemoveAgentComponent } from './dialogs/dialog-remove-agent/dialog-remove-agent.component';
import { DialogRecalculateComponent } from './dialogs/dialog-recalculate/dialog-recalculate.component';
import { DialogDropout } from './dialogs/dialog-dropout/dialog-dropout.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { IconButtonComponent } from './ui/icon-button/icon-button.component';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { StatsTableComponent } from './panel-components/home/stats-table/stats-table.component';
import { PopupComponent } from './ui/popup/popup.component';
import { DialogConfirmStatsRecalculationComponent } from './dialogs/dialog-confirm-stats-recalculation/dialog-confirm-stats-recalculation.component';
import { DialogUnsubscribeOfficeComponent } from './dialogs/dialog-unsubscribe-office/dialog-unsubscribe-office.component';
import { DialogSubscribeOffice } from './dialogs/dialog-subscribe-office/dialog-subscribe-office.component';
import { DialogOfficesComponent } from './dialogs/dialog-offices/dialog-offices.component';
import { OfficesTableComponent } from './dialogs/dialog-offices/offices-table/offices-table.component';
import { DialogChangePasswordComponent } from './dialogs/dialog-change-password/dialog-change-password.component';
import { TableHeaderNewComponent } from './ui/table-header-new/table-header-new.component';
import { PaginationComponent } from './ui/pagination/pagination.component';
import { TableRowComponent } from './electronic-billing/table-row/table-row.component';
import { AgentsRowComponent } from './electronic-billing/agents-row/agents-row.component';
import { ElectronicBillingSaveComprobantesComponent } from './dialogs/electronic-billing-save-comprobantes/electronic-billing-save-comprobantes.component';
import { SolicitateCaeDialogComponent } from './dialogs/solicitate-cae-dialog/solicitate-cae-dialog.component';
import { ElectronicBillingActionsComponent } from './dialogs/electronic-billing-actions/electronic-billing-actions.component';
import { ElectronicBillingSendIndividualEmailDialogComponent } from './dialogs/electronic-billing-send-individual-email/electronic-billing-send-individual-email.component';
import { ElectronicBillingAfipStatusComponent } from './dialogs/electronic-billing-afip-status/electronic-billing-afip-status.component';
import { ConfigResetUserPasswordComponent } from './dialogs/config-reset-user-password/config-reset-user-password.component';
import { ConfigDeleteUserComponent } from './dialogs/config-delete-user/config-delete-user.component';
import { NotificationsComponent } from './config/notifications/notifications.component';
import { UsersComponent } from './config/users/users.component';
import { ObjectivesComponent } from './config/objectives/objectives.component';
import { ConfigDownloadExcelObjectivesComponent } from './dialogs/config-download-excel-objectives/config-download-excel-objectives.component';
import { ConfigAddExceptionComponent } from './dialogs/config-add-exception/config-add-exception.component';
import { ConfigObjectivesDetailedComponent } from './dialogs/config-objectives-detailed/config-objectives-detailed.component';
import { ElectronicBillingGenerateCreditNoteComponent } from './dialogs/electronic-billing-generate-credit-note/electronic-billing-generate-credit-note.component';
import { ElectronicBillingDownloadLibroIvaComponent } from './dialogs/electronic-billing-download-libro-iva/electronic-billing-download-libro-iva.component';
import { RrhhAgentsTabComponent } from './rrhh/rrhh-agents-tab/rrhh-agents-tab.component';
import { RrhhTeamsTabComponent } from './rrhh/rrhh-teams-tab/rrhh-teams-tab.component';
import { RrhhUnifyTabComponent } from './rrhh/rrhh-unify-tab/rrhh-unify-tab.component';
import { CashflowsComponent } from './config/cashflows/cashflows.component';
import { ConfigEditCashflowNameComponent } from './dialogs/config-edit-cashflow-name/config-edit-cashflow-name.component';
import { JurisdictionComponent } from './config/jurisdiction/jurisdiction.component';
import { ConfigAddEditCompensationComponent } from './dialogs/config-add-edit-compensation/config-add-edit-compensation.component';
import { ConfigDeleteCompensationComponent } from './dialogs/config-delete-compensation/config-delete-compensation.component';
import { ElectronicBillingDataComponent } from './config/electronic-billing-data/electronic-billing-data.component';
import { ConfigAddEditNotificationsComponent } from './dialogs/config-add-edit-notifications/config-add-edit-notifications.component';
import { DateRangeComponent } from './dialogs/date-range/date-range.component';
import { RrhhDisableTeamComponent } from './dialogs/rrhh-disable-team/rrhh-disable-team.component';
import { RrhhRemoveAgentComponent } from './dialogs/rrhh-remove-agent/rrhh-remove-agent.component';
import { RrhhInfoFormComponent } from './rrhh/rrhh-info-form/rrhh-info-form.component';
import { RrhhDataFormComponent } from './rrhh/rrhh-data-form/rrhh-data-form.component';
import { RrhhArchivesFormComponent } from './rrhh/rrhh-archives-form/rrhh-archives-form.component';
import { UbicationGoogleComponent } from './ubication-google/ubication-google.component';
import { MapOsmComponent } from './map-osm/map-osm.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { LeafletDrawModule } from '@asymmetrik/ngx-leaflet-draw';
import { RrhhPhotoExampleComponent } from './dialogs/rrhh-photo-example/rrhh-photo-example.component';
import { ConfigDeleteJurisdictionComponent } from './dialogs/config-delete-jurisdiction/config-delete-jurisdiction.component';
import { RrhhTeamInfoFormComponent } from './rrhh/rrhh-team-info-form/rrhh-team-info-form.component';
import { RrhhTeamMembersFormComponent } from './rrhh/rrhh-team-members-form/rrhh-team-members-form.component';
import { RrhhConfirmReactivateMemberComponent } from './dialogs/rrhh-confirm-reactivate-member/rrhh-confirm-reactivate-member.component';
import { JupiterBlockComponent } from './jupiter-block/jupiter-block.component';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { JupiterBlockDialogComponent } from './dialogs/jupiter-block-dialog/jupiter-block-dialog.component';
import { AltaEmisorBlockComponent } from './alta-emisor-block/alta-emisor-block.component';
import { RrhhAltaRemaxComponent } from './dialogs/rrhh-alta-remax/rrhh-alta-remax.component';
import { DatePickerComponent } from './ui/date-picker/date-picker.component';
import { MatCardModule } from '@angular/material/card';
import { NgxPrintModule } from 'ngx-print';
import { CommissionSummaryComponent } from './renditions/commission-summary/commission-summary.component';
import { ReserveSelectionComponent } from './renditions/reserve-selection/reserve-selection.component';
import { RenditionFullFormComponent } from './renditions/rendition-full-form/rendition-full-form.component';
import { RenditionDeleteDraftComponent } from './dialogs/renditions/rendition-delete-draft/rendition-delete-draft.component';
import { RenditionDeleteRenditionComponent } from './dialogs/renditions/rendition-delete-rendition/rendition-delete-rendition.component';
import { RenditionDownloadsComponent } from './dialogs/renditions/rendition-downloads/rendition-downloads.component';
import { DialogAddInvoiceComponent } from './renditions/dialog-add-invoice/dialog-add-invoice.component';
import { RenditionPrintViewComponent } from './renditions/rendition-print-view/rendition-print-view.component';
import { RenditionCaptorAgentCellComponent } from './renditions/rendition-captor-agent-cell/rendition-captor-agent-cell.component';
import { RenditionMovementDeleteAllComponent } from './dialogs/renditions/rendition-movement-delete-all/rendition-movement-delete-all.component';
import { RenditionMovementGenerateAutomaticComponent } from './dialogs/renditions/rendition-movement-generate-automatic/rendition-movement-generate-automatic.component';
import { RenditionMovementSplitComponent } from './dialogs/renditions/rendition-movement-split/rendition-movement-split.component';
import { RenditionMovementPendingAmountComponent } from './dialogs/renditions/rendition-movement-pending-amount/rendition-movement-pending-amount.component';
import { RenditionFinishMovementsComponent } from './dialogs/renditions/rendition-finish-movements/rendition-finish-movements.component';
import { RenditionFormLoadDraftComponent } from './dialogs/renditions/rendition-form-load-draft/rendition-form-load-draft.component';
import { RenditionClearFormComponent } from './dialogs/renditions/rendition-clear-form/rendition-clear-form.component';
import { RenditionDraftCreatedComponent } from './dialogs/renditions/rendition-draft-created/rendition-draft-created.component';
import { LoaderFullScreenComponent } from './ui/loader-full-screen/loader-full-screen.component';
import { OverlayComponent } from './ui/overlay/overlay.component';
import { OverlayTopbarComponent } from './ui/overlay-topbar/overlay-topbar.component';
import { RenditionWarningForInvalidCapsInvoicesComponent } from './dialogs/renditions/rendition-warning-for-invalid-caps-invoices/rendition-warning-for-invalid-caps-invoices.component';
import { TextareaComponent } from './ui/textarea/textarea.component';
import { ButtonWrapperComponent } from './ui/button-wrapper/button-wrapper.component';
import { RenditionUpdateInvoicesComponent } from './dialogs/renditions/rendition-update-invoices/rendition-update-invoices.component';
import { RrhhImportTeamComponent } from './dialogs/rrhh-import-team/rrhh-import-team.component';
import { InputAutocompleteWithServiceComponent } from './ui/input-autocomplete-with-service/input-autocomplete-with-service.component';
import { BlockEditDifferentModuleComponent } from './renditions/dialogs/block-edit-different-module/block-edit-different-module.component';
import { RecruitmentConfigComponent } from './config/recruitment/recruitment.component';
import { RecruitmentConfigScoreComponent } from './config/recruitment/config-score/config-score.component';
import { RecruitmentConfigStagesAndPhasesComponent } from './config/recruitment/config-stages-and-phases/config-stages-and-phases.component';
import { RecruitmentTagStagePhaseComponent } from '../pages/recruitment/components/tag-stage-phase/tag-stage-phase.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SearchAutocompleteComponent } from './ui/search-autocomplete/search-autocomplete.component';
import { ElectronicBillingBlockComponent } from './electronic-billing/electronic-billing-block/electronic-billing-block.component';
import { RrhhChangeDateAgentComponent } from './dialogs/rrhh-change-date-agent/rrhh-change-date-agent.component';
import { DialogAddIncomeComponent } from '../pages/movements/components/dialogs/dialog-add-income/dialog-add-income.component';
import { DialogsDetailMovementComponent } from '../pages/movements/components/dialogs/dialogs-detail-movement/dialogs-detail-movement.component';
import { DialogDeleteMovementComponent } from '../pages/movements/components/dialogs/dialog-delete-movement/dialog-delete-movement.component';
import { DialogPreviewComponent } from '../pages/stats/stats-list/components/dialogs/dialog-preview-reservation/dialog-preview-reservation.component';
import { DialogDownloadListComponent } from '../pages/stats/stats-list/components/dialogs/dialog-download-list/dialog-download-list.component';
import { DialogPreviewReservationComponent } from '../pages/stats/reservometro/components/dialogs/dialog-preview-reservation/dialog-preview-reservation.component';
import { DialogSolicitudActualizacionComponent } from '../pages/stats/reservometro/components/dialogs/dialog-solicitud-actualizacion/dialog-solicitud-actualizacion.component';
import { DialogDeleteReservationComponent } from './dialogs/dialog-delete-reservation/dialog-delete-reservation/dialog-delete-reservation.component';
import { SimpleUpdateRequestComponent } from '../pages/stats/reservometro/components/dialogs/simple-update-request/simple-update-request.component';
import { IfNodeModule } from '@base/src/app/directives/if-node-directive/if-node.module';
import { DialogDeleteNoteComponent } from './dialogs/dialog-delete-note/dialog-delete-note.component';

const components: any[] = [
  IconButtonComponent,
  ButtonComponent,
  IconComponent,
  PopupComponent,
  ToggleComponent,
  DropdownComponent,
  InputComponent,
  DialogComponent,
  DialogSubscribeOffice,
  DialogExampleComponent,
  DialogLimpiarCuentaCorriente,
  DialogRemoveAgentComponent,
  DialogUnsubscribeOfficeComponent,
  TableHeaderNewComponent,
  DialogChangePasswordComponent,
  DialogRecalculateComponent,
  DialogDropout,
  RankingUpdateDataComponent,
  QrRankingItemComponent,
  InputAutocompleteComponent,
  DialogFullScreenComponent,
  AvatarComponent,
  TabsComponent,
  TopbarComponent,
  PanelHomeComponent,
  SkeletonLoaderComponent,
  FilterRankingComponent,
  ChipComponent,
  ChipOutlineComponent,
  ButtonOrderComponent,
  RankingTableAveragesComponent,
  TableHeaderComponent,
  QrRankingItemComponent,
  StatsTableComponent,
  DialogConfirmStatsRecalculationComponent,
  PaginationComponent,
  TableRowComponent,
  AgentsRowComponent,
  ElectronicBillingSaveComprobantesComponent,
  ElectronicBillingSendIndividualEmailDialogComponent,
  ElectronicBillingActionsComponent,
  SolicitateCaeDialogComponent,
  ConfigDeleteUserComponent,
  ConfigResetUserPasswordComponent,
  UsersComponent,
  NotificationsComponent,
  ConfigDeleteUserComponent,
  ConfigResetUserPasswordComponent,
  ElectronicBillingAfipStatusComponent,
  TableHeaderNewComponent,
  OfficesTableComponent,
  DialogOfficesComponent,
  ObjectivesComponent,
  ConfigDownloadExcelObjectivesComponent,
  ConfigAddExceptionComponent,
  ConfigObjectivesDetailedComponent,
  RrhhAgentsTabComponent,
  RrhhTeamsTabComponent,
  RrhhUnifyTabComponent,
  ElectronicBillingGenerateCreditNoteComponent,
  ElectronicBillingDownloadLibroIvaComponent,
  CashflowsComponent,
  ConfigEditCashflowNameComponent,
  JurisdictionComponent,
  ConfigAddEditCompensationComponent,
  ConfigDeleteCompensationComponent,
  ElectronicBillingDataComponent,
  ConfigAddEditNotificationsComponent,
  DateRangeComponent,
  RrhhDisableTeamComponent,
  RrhhInfoFormComponent,
  RrhhDataFormComponent,
  RrhhArchivesFormComponent,
  MapOsmComponent,
  UbicationGoogleComponent,
  RrhhPhotoExampleComponent,
  RrhhRemoveAgentComponent,
  ConfigDeleteJurisdictionComponent,
  RrhhTeamInfoFormComponent,
  RrhhTeamMembersFormComponent,
  RrhhConfirmReactivateMemberComponent,
  JupiterBlockComponent,
  JupiterBlockDialogComponent,
  AltaEmisorBlockComponent,
  RrhhAltaRemaxComponent,
  DatePickerComponent,
  CommissionSummaryComponent,
  ReserveSelectionComponent,
  RenditionFullFormComponent,
  RenditionDeleteDraftComponent,
  RenditionDeleteRenditionComponent,
  RenditionDownloadsComponent,
  DialogAddInvoiceComponent,
  RenditionPrintViewComponent,
  RenditionCaptorAgentCellComponent,
  RenditionMovementDeleteAllComponent,
  RenditionMovementGenerateAutomaticComponent,
  RenditionMovementSplitComponent,
  RenditionMovementPendingAmountComponent,
  RenditionFinishMovementsComponent,
  RenditionFormLoadDraftComponent,
  RenditionClearFormComponent,
  RenditionDraftCreatedComponent,
  RrhhImportTeamComponent,
  LoaderFullScreenComponent,
  OverlayComponent,
  OverlayTopbarComponent,
  RenditionWarningForInvalidCapsInvoicesComponent,
  TextareaComponent,
  ButtonWrapperComponent,
  InputAutocompleteWithServiceComponent,
  RenditionUpdateInvoicesComponent,
  BlockEditDifferentModuleComponent,
  RecruitmentConfigComponent,
  RecruitmentConfigScoreComponent,
  RecruitmentConfigStagesAndPhasesComponent,
  RecruitmentTagStagePhaseComponent,
  SearchAutocompleteComponent,
  ElectronicBillingBlockComponent,
  RrhhChangeDateAgentComponent,
  DialogsDetailMovementComponent,
  DialogAddIncomeComponent,
  DialogDeleteMovementComponent,
  DialogPreviewReservationComponent,
  DialogDownloadListComponent,
  DialogPreviewComponent,
  DialogPreviewReservationComponent,
  DialogSolicitudActualizacionComponent,
  DialogDeleteReservationComponent,
  SimpleUpdateRequestComponent,
  DialogDeleteNoteComponent,
];
@NgModule({
  imports: [
    IfNodeModule,
    RouterModule,
    LeafletDrawModule,
    LeafletModule,
    FormsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    SharedModule,
    MatRippleModule,
    MatTooltipModule,
    MatMenuModule,
    MatSelectModule,
    FormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    NgxSliderModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    SwiperModule,
    MatDatepickerModule,
    MatCardModule,
    MatNativeDateModule,
    NgxPrintModule,
    ReactiveFormsModule,
    DragDropModule,
    MatTooltipModule,
    MatMenuModule,
    MatCheckboxModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
  ],
  declarations: [...components, DialogDeleteNoteComponent],
  exports: [...components],
  providers: [],
})
export class ComponentsModule {}
